module.exports = __webpack_public_path__ + "static/media/logo.9a5e9524.svg";